import { Breadcrumbs } from "components/breadcrumbs";
import React from 'react';
import { EventType } from "interfaces";
import { ImportParticipant } from "../components";

export const MassImportAttractionParticipant: React.FC = () => {      
  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Create & Update Attraction participant" />
      <ImportParticipant eventType={EventType.ATTRACTION} />
    </div>
  );
};
